import {
  BuyerAccessLevel,
  OperatorAccessLevel,
  SupplierAccessLevel,
} from '@ps/core-models';

/**
 * MultiBuyer Manager shares the `multiBuyer` wire value with MultiBuyer PM and
 * differs only by the `isMBManager` flag, so both options need a discriminant
 * to coexist without a cast.
 */
export interface StandardBuyerAccessLevelOption {
  kind: 'standard';
  value: BuyerAccessLevel;
  label: string;
}

export interface MultiBuyerManagerAccessLevelOption {
  kind: 'multiBuyerManager';
  value: 'multiBuyer';
  label: string;
}

export type BuyerAccessLevelOption =
  | StandardBuyerAccessLevelOption
  | MultiBuyerManagerAccessLevelOption;

export interface OperatorAccessLevelOption {
  value: OperatorAccessLevel;
  label: string;
}

export interface SupplierAccessLevelOption {
  value: SupplierAccessLevel;
  label: string;
}

export const isMultiBuyerManagerOption = (
  option: BuyerAccessLevelOption,
): option is MultiBuyerManagerAccessLevelOption =>
  option.kind === 'multiBuyerManager';

/** Synthetic key: a select cannot tell the two `multiBuyer` options apart. */
export const buyerAccessLevelKeyOf = (
  value: BuyerAccessLevel,
  isMultiBuyerManager: boolean,
): string => (isMultiBuyerManager ? `${value}:manager` : value);

export const buyerAccessLevelOptionKey = (
  option: BuyerAccessLevelOption,
): string =>
  buyerAccessLevelKeyOf(option.value, isMultiBuyerManagerOption(option));

export const findBuyerAccessLevelOption = (
  options: readonly BuyerAccessLevelOption[],
  key: string,
): BuyerAccessLevelOption | null =>
  options.find((option) => buyerAccessLevelOptionKey(option) === key) ?? null;
